@if (isMobileSmDown() || countItems()) {
  <div class="cart-header">
    @if (isTabletMdDown()) {
      <div class="cart-header-navigation">
        <button class="color-black btn-icon" tabindex="0" (click)="onNavigationBack()">
          <sd-icon class="icon-size-md-m" [type]="iconTypes.ARROW_PREV"></sd-icon>
        </button>
      </div>
    }
    @if (countItems()) {
      <div class="cart-header-details text-b1-l-700 text-lg-h3-m color-black">
        корзина
        <span class="cart-header-details-count text-b4-s-300 text-lg-c1-l-300 color-black-warm-800">
          @if (isTabletMdDown()) {
            /
          }
          {{ countItems() }} шт
        </span>
      </div>

      <sd-cart-actions></sd-cart-actions>
    }
  </div>
}
